import {List} from 'immutable';
import {javaApiFor} from './api';

const api = javaApiFor('/api/folders');

export default {
  // fetch tags width item counts based on what filters are supplied
  fetchTags(filters) {
    return api
      .postJson(
        `/${filters.folderId}/count_unviewed_by_tags`,
        filters
          // filters part of url, not get params
          .delete('folderId')
          .toJS()
      )
      .then(tags => List(tags));
  },
};
